export enum CenterType {    
    Prospect = 1,
    MemberCenter = 2
}